import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { TabSyncService } from './tab-sync.service';

@Injectable({
  providedIn: 'root',
})
export class SessionTimeoutService {
  private timeout: any;
  private readonly sessionTime = 15 * 60 * 1000; // 15 minutes

  // Activity is broadcast to the other tabs at most this often. mousemove fires continuously,
  // and every tab would otherwise rebroadcast on each one; the timer only needs to know the
  // user is alive, so one message per interval is plenty.
  private readonly broadcastEvery = 30 * 1000;
  private lastBroadcast = 0;

  constructor(private router: Router, private tabSync: TabSyncService) {
    // Activity in ANY tab keeps this one alive. Without this a background tab sees no
    // mousemove/keydown of its own, so it idled out — and cleared the session — while the
    // user was still working in another tab. Received activity must NOT be rebroadcast,
    // or two tabs would keep echoing each other forever.
    this.tabSync.on('activity').subscribe(() => this.resetTimer(false));
    this.resetTimer();
  }

  /**
   * @param broadcast tell the other tabs the user is active. False when the reset was itself
   *                  caused by another tab's message.
   */
  resetTimer(broadcast: boolean = true) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.logout();
    }, this.sessionTime);

    if (broadcast) {
      const now = Date.now();
      if (now - this.lastBroadcast >= this.broadcastEvery) {
        this.lastBroadcast = now;
        this.tabSync.post({ type: 'activity' });
      }
    }
  }

  logout() {

    sessionStorage.clear();
    if (environment.isLogoOutFromLive === '1') {
      window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
    } else {
      this.router.navigate(['/Login']);
    }
  }

}
